export const BoardstoryGameTypes = {
  Impulse: 'impulse',
  Quiz: 'quiz',
  Search: 'search',
};
